module.exports = __webpack_public_path__ + "static/accessibility-94a18fbc409d893d0f8b43e00e9d7e15.png";